import $ from 'jquery';
import { subscribe } from 'Util/pubsub';

let $jumpLinks;
let $jumpLinksContainer;
let $header;
let sections = [];

const JumpLinks = {
    init: function () {
        $jumpLinks = $('.js-jumplinks__item');
        $jumpLinksContainer = $('.js-jumplinks');
        $header = $('.js-header');

        if ($jumpLinks.length === 0) {
            return;
        }

        JumpLinks._initSections();
        JumpLinks._initEvents();
        JumpLinks._updateActiveLink(); // Set initial active state
    },

    _initSections: function () {
        sections = [];
        $jumpLinks.each(function () {
            const targetId = $(this).attr('href');
            const $target = $(targetId);

            if ($target.length) {
                sections.push({
                    link: this,
                    target: $target
                });
            }
        });
    },

    _initEvents: function () {
        $jumpLinks.on('click', function (event) {
            event.preventDefault();

            // Remove active from all links
            $jumpLinks.removeClass('active');
            // Add active to clicked link
            $(this).addClass('active');

            const targetId = $(this).attr('href');
            const $target = $(targetId);

            if ($target.length) {
                const targetTop = $target.offset().top;
                const currentScrollPosition = $(window).scrollTop();

                // is-down/is-up are applied during scroll, not at click time.
                // Predict the final header state from scroll direction instead.
                const scrollingUp = targetTop < currentScrollPosition;
                const headerOffset = ($header.length && scrollingUp) ? $header.outerHeight(true) : 0;
                const jumplinksOffset = $jumpLinksContainer.length ? $jumpLinksContainer.outerHeight(true) : 0;
                const offset = headerOffset + jumplinksOffset;

                const targetPosition = targetTop - offset;

                $('html, body').animate({
                    scrollTop: targetPosition
                }, 600, 'swing');
            }

            return false;
        });

        subscribe('/window/scroll', JumpLinks._updateActiveLink);
    },

    _updateActiveLink: function () {
        const scrollPosition = $(window).scrollTop();
        // Use header height unless it is explicitly hidden (is-up). This handles the
        // case where neither class has been applied yet (e.g. on initial load).
        const headerOffset = ($header.length && $header.hasClass('is-down')) ? $header.outerHeight(true) : 0;
        const jumplinksOffset = $jumpLinksContainer.length ? $jumpLinksContainer.outerHeight(true) : 0;
        const offset = headerOffset + jumplinksOffset;

        let currentSection = null;

        // Find which section has most recently scrolled past the top
        // We iterate through sections and keep the last one that has passed the threshold
        sections.forEach(function (section) {
            const sectionTop = section.target.offset().top - offset;

            // If this section has scrolled past the top, it becomes the current active section
            if (scrollPosition >= sectionTop) {
                currentSection = section.link;
            }
        });

        // Update active class
        $jumpLinks.removeClass('active');

        if (currentSection) {
            $(currentSection).addClass('active');
        }

        // Check if header has .is-down class and mirror it to jumplinks
        if ($header.length && $jumpLinksContainer.length) {
            if ($header.hasClass('is-down')) {
                $jumpLinksContainer.addClass('is-down');
            } else {
                $jumpLinksContainer.removeClass('is-down');
            }
        }
    }
};

export { JumpLinks };